import { render } from "./RoleCloneModal.vue?vue&type=template&id=5d1a0495&scoped=true&ts=true"
import script from "./RoleCloneModal.vue?vue&type=script&lang=ts"
export * from "./RoleCloneModal.vue?vue&type=script&lang=ts"

import "./RoleCloneModal.vue?vue&type=style&index=0&id=5d1a0495&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1a0495"]])

export default __exports__